<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-heart-rate`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33.147 4C40.444 4 46 10.354 46 18.24c0 3.795-1.03 6.22-3.578 10.198-1.973 3.08-5.27 6.593-9.407 10.32a120.722 120.722 0 01-4.318 3.705 89.925 89.925 0 01-2.032 1.622 4.362 4.362 0 01-2.666.915c-.956 0-1.89-.319-2.664-.914-.447-.344-1.15-.9-2.033-1.623a120.742 120.742 0 01-4.318-3.705c-4.137-3.728-7.434-7.24-9.407-10.32C3.029 24.459 2 22.034 2 18.239 2 10.422 7.904 4 15.252 4c3.185 0 6.09 1.022 8.657 3.025C26.515 5.015 29.617 4 33.147 4zM9.914 27.669c1.809 2.412 4.498 5.19 7.747 8.117 1.4 1.262 2.814 2.468 4.174 3.582.85.695 1.522 1.226 1.938 1.547a.374.374 0 00.226.085.367.367 0 00.228-.086c.405-.312 1.086-.85 1.937-1.546 1.36-1.114 2.773-2.32 4.174-3.582 3.249-2.927 5.938-5.705 7.747-8.117h-6.297L26.096 21.4l-6.73 12-5.732-5.73-3.72-.001zm15.399-16.568C27.423 9.024 29.996 8 33.147 8 38.107 8 42 12.453 42 18.24c0 2.004-.394 3.512-1.398 5.43h-7.043l-8.234-9.07-6.865 12.238-3.17-3.168H7.398C6.394 21.751 6 20.243 6 18.24 6 12.56 10.191 8 15.252 8c2.711 0 5.102 1.015 7.266 3.112l1.403 1.36 1.392-1.37z"/></svg>
</template>
<script>

export default {
  name: 'IconHeartRate',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
